module.exports = __webpack_public_path__ + "static/media/Parisienne-Regular.2ef637e2.ttf";